import type { RemoteLogger } from '@/plugin/app-insights/app-insights-plugin'
import { inject } from 'vue'

export function useRemoteLogger() {
  const logger = inject<RemoteLogger>('$remoteLogger')!
  return { ...logger }
}

